// extracted by extract-css-chunks-webpack-plugin
module.exports = {"strong":"strong___2p6su"};